import { v4 as uuidv4 } from 'uuid';

//Create temporary ids that are used when uploading images.
export const createTempImageId = () => `temp-${uuidv4()}`;
export const isTempImageId = (id: string) => !!id?.startsWith('temp-');
